// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","recommend":"recommend-NKApG","recommend__icon":"recommend__icon-cQmGD","slider":"slider-3p8ph"};